module.exports = __webpack_public_path__ + "statics/img/1.1b2b3ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/wap/1.png
// module id = Ue0U
// module chunks = 1